<template name="preview-imgs">
	<div>
		<!-- 图片预览 -->
		<el-dialog
		  :title="title"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		  width="800px" top="10vh"
		>
			<div class="gp-preview-item">
				<div class="img-view_active">
					<img :src="imgs[imgs_index]" />
				</div>
				<div class="imgs-list" ref="imgs-list">
					<template v-for="(item, index) in imgs">
						<div
						  :class="index == imgs_index ? 'active img-view_pre' : 'img-view_pre'"
						  @click="change(index)"
						>
							<img :src="item" />
						</div>
					</template>
				</div>
			</div>
			<template v-if="desc.length > 0">
				<div class="desc">{{desc}}</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: "",
			},
			desc: {
				type: String,
				default: "",
			},
			imgs: {
				type: Array,
				default: [],
			},
			imgs_index: {
				type: Number,
				default: 0
			},
		},
		methods: {
			close() {
				this.$refs['imgs-list'].scrollTop = 0;
				this.$emit('close');
			},
			change(index) {
				this.$emit('change', {index: index});
			},
		}
	}
</script>

<style>
	.el-textarea {
	    padding: 0 20px;
	    box-sizing: border-box;
	}
	
	.gp-preview-item {
		padding-bottom: 12px;
		display: flex;
	}
	
	.gp-preview-item .active {
		border: #FEC418 2px solid;
	}
	
	.img-view_active {
		width: 587px;
		height: 418px;
		background: #F2F6FC;
		margin-right: 64px;
		margin-left: 20px;
	}
	
	.img-view_active img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	
	.imgs-list {
		width: 100px;
		height: 418px;
		display: flex;
		flex-direction: column;
		overflow: auto;
	}
	
	.img-view_pre {
		width: 70px;
		height: 70px;
		margin-bottom: 12px;
		cursor: pointer;
		border: #ffffff 2px solid;
	}
	
	.img-view_pre img {
		display: block;
		width: 70px;
		height: 70px;
		object-fit: cover;
	}
	
	.desc {
		margin: 0 20px 10px;
		font-size: 12px;
		font-weight: 500;
		color: #666666;
		line-height: 18px;
		word-break: break-all;
	}
</style>
